import { POST } from "../../index";

export const getFenceTerminal = (param) => POST("/v1/electronicFence/getFenceTerminal", param);
export const getElectronicFence = (param) => POST("/v1/electronicFence/getElectronicFence", param);
export const insertElectronicFence = (param) => POST("/v1/electronicFence/insertElectronicFence", param);
export const updateElectronicFence = (param) => POST("/v1/electronicFence/updateElectronicFence", param);
export const deleteElectronicFence = (param) => POST("/v1/electronicFence/deleteElectronicFence", param);
export const getFenceCarMessage = (param) => POST("/v1/car/getFenceCarMessage", param);
export const getChoiceTerminal = (param) => POST("/v1/electronicFence/getChoiceTerminal", param);


